
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.51 2.59S39 9.16 36.38 12.76 13.08 33 9.48 35.55c-1.63 1.17-3.61 1.53-5 .11s-1.17-3.51 0-5.14C7 26.92 23.64 6.19 27.24 3.62s10.27-1.03 10.27-1.03z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M10.48 22.47c-.1 0-6-2.22-6-2.22l-3.07 3.06 4.94 5M17.53 29.52c0 .1 2.22 6 2.22 6l-3.06 3.06-5-4.94M22.68 8.81L7.89 1.41l-3.6 3.6L15.98 16.7M31.19 17.32l7.4 14.79-3.6 3.59L23.3 24.02","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    